import TransportPermits from './TransportPermitsProvider';

export default TransportPermits;
